import React from 'react';

export const DesktopComputerSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6933_3339)">
          <path fill-rule="evenodd" clipRule="evenodd" d="M32 26C34.209 26 36 24.209 36 22V4C36 1.791 34.209 0 32 0H4C1.791 0 0 1.791 0 4V22C0 24.209 1.791 26 4 26H32ZM32 4H4V22H32V4Z" fill={color} />
          <path d="M13 26H23V32H13V26Z" fill={color} />
          <path d="M13 26H23V28H13V26Z" fill={color} />
          <path d="M36 33C36 31.343 34.657 30 33 30H3C1.343 30 0 31.343 0 33C0 34.657 1.343 36 3 36H33C34.657 36 36 34.657 36 33Z" fill={color} />
          <path d="M3 32H5V34H3V32ZM7 32H9V34H7V32ZM11 32H13V34H11V32ZM15 32H17V34H15V32ZM19 32H21V34H19V32ZM23 32H25V34H23V32ZM27 32H29V34H27V32ZM31 32H33V34H31V32Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_6933_3339">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5996_18918)">
        <path d="M36 22C36 24.209 34.209 26 32 26H4C1.791 26 0 24.209 0 22V4C0 1.791 1.791 0 4 0H32C34.209 0 36 1.791 36 4V22Z" fill="#E3E3E3" />
        <path d="M4 4H32V22H4V4Z" fill="#5DBBF0" />
        <path d="M13 26H23V32H13V26Z" fill="#E3E3E3" />
        <path d="M13 26H23V28H13V26Z" fill="#B1B1B1" />
        <path d="M36 33C36 31.343 34.657 30 33 30H3C1.343 30 0 31.343 0 33C0 34.657 1.343 36 3 36H33C34.657 36 36 34.657 36 33Z" fill="#E3E3E3" />
        <path d="M3 32H5V34H3V32ZM7 32H9V34H7V32ZM11 32H13V34H11V32ZM15 32H17V34H15V32ZM19 32H21V34H19V32ZM23 32H25V34H23V32ZM27 32H29V34H27V32ZM31 32H33V34H31V32Z" fill="#F4F4F4" />
      </g>
      <defs>
        <clipPath id="clip0_5996_18918">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}